import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        let serializedUrl: UrlTree = super.parse(url);
        if (!url.includes('reset-password')) serializedUrl = super.parse(url.toLowerCase());

        return serializedUrl;
    }
}